export default __webpack_public_path__ + "static/park-card-3522958383cc7b9802ae5bfbec1d5a36.png";